import { useState } from "react";
import { useForm } from "react-hook-form";
import { assetUrl } from "fusion-core";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { formatDateT } from "../../../../shared/utils/formatters";
import NewDateTimePicker from "../../../../shared/components/newDateTimePicker";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import useQuoteStore from "../../../quote/store/QuoteStore";
import ModalWrapper from "../../../../shared/components/ModalWrapper";
import ModalActionButtons from "../../../../shared/components/ModalActionButtons";

const PolicyDateTimeModal = ({ actions, onClose }) => {
  const {
    watch,
    setValue,
    control,
    handleSubmit,
    formState: { errors, isValid },
    trigger,
  } = useForm();
  const STATE = useAppStateStore();

  const [isEditMode, setIsEditMode] = useState(false);
  const customerQuotes = STATE.customerQuotes;

  const handleYesClick = async () => {
    actions();
    onClose();
  };

  const handleConfirmClick = () => {
    const { updateField } = useQuoteStore.getState();
    const newDate = formatDateT(watch("date"));
    updateField("risk.startDate", newDate);
    actions();
    onClose();
  };

  return (
    <ModalWrapper heading="Confirm Start Date" onClose={onClose}>
      <Helmet>
        <link
          rel="stylesheet"
          href={assetUrl("../../../../styles/TqPolicyDateTimeModal.css")}
        />
      </Helmet>
      <form onSubmit={handleSubmit(handleConfirmClick)}>
        {!isEditMode ? (
          <>
            <div>
              <div className="policy-date-time-div">
                <div className="policy-date-time-header">Cover start date</div>
                <div>
                  {customerQuotes?.startDate
                    ?.split("T")[0]
                    .split("-")
                    .reverse()
                    .join("/")}
                </div>
              </div>
              <div className="policy-date-time-div">
                <div className="policy-date-time-header">Cover start time</div>
                <div>{customerQuotes?.startDate?.split("T")[1]}</div>
              </div>
            </div>
            <ModalActionButtons
              label="Cover start date and time cannot be in the past."
              primaryText="Yes"
              secondaryText="Edit"
              onPrimaryClick={handleYesClick}
              onSecondaryClick={() => setIsEditMode(true)}
              primaryType="button"
              secondaryType="button"
              primaryDisabled={true}
            />
          </>
        ) : (
          <>
            <div>
              <NewDateTimePicker
                name="date"
                label="When would you like your cover to start?"
                errors={errors.date}
                setValue={setValue}
                control={control}
                rules={{
                  required: "Date is required",
                }}
                watch={watch}
                trigger={trigger}
                defaultValue={watch("date")}
                minDate={new Date()}
                maxDate={
                  new Date(new Date().setDate(new Date().getDate() + 29))
                }
              />
              <ModalActionButtons
                label="A change in cover start date may result in a change in price."
                primaryText="Confirm"
                secondaryText="Cancel"
                onPrimaryClick={isValid ? handleConfirmClick : undefined}
                onSecondaryClick={() => setIsEditMode(false)}
                primaryType="submit"
                secondaryType="button"
                primaryDisabledStyle={!isValid}
              />
            </div>
          </>
        )}
      </form>
    </ModalWrapper>
  );
};

export default PolicyDateTimeModal;
